import { render, staticRenderFns } from "./UsageTermsEdit.vue?vue&type=template&id=649086fc&scoped=true"
import script from "./UsageTermsEdit.vue?vue&type=script&lang=js"
export * from "./UsageTermsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649086fc",
  null
  
)

export default component.exports